import request from '../utils/axios';
import UAParser from '@amplitude/ua-parser-js';
import Cookies from 'cookies-js';
const parser = new UAParser();

const getIp = async () => {
  const res = await request.get(process.env.VUE_APP_STAT_IP_URL);
  return res.data || {};
};

const defaultParams = async () => {
  const browser = parser.getBrowser();
  const os = parser.getOS();
  const device = parser.getDevice();
  const navigator = window.navigator;
  // const performance = window.performance
  // console.log(window.performance.getEntriesByType('mark'))
  // console.log(window.performance.getEntriesByType('navigation'))
  const ipJson = await getIp();

  return {
    url: (window && window.location.href) || '', // 当前的URL
    rurl: (document && document.referrer) || '', // 上一个页面地址
    src: window.screen.width + 'x' + window.screen.height, // 屏幕分辨率: 如 1600x900'
    scl: window.screen.colorDepth || 0, // '屏幕颜色深度：如 24-bit'
    lg: navigator.language || navigator.browserLanguage, // '浏览器语言：如 zh-cn'
    tz: 0 - new Date().getTimezoneOffset() / 60, // 时区
    os: `${os.name}/${os.version}`, //操作系统
    bs: `${browser.name}/${browser.version}`, // 浏览器及版本
    ps: '', //页面加载用时：如 271 单位为毫秒
    jv: navigator.javaEnabled() ? 1 : 0, //
    sh: document.documentElement.scrollHeight, //滚动条可滚动高度
    ip: ipJson['ip'] || '', //
    addr: ipJson['city'] || '', //
    device: device.model,
    pvi: getPvi(),
  };
};
const getPvi = () => {
  const pvi = Cookies.get('pgv_pvi');
  if (pvi) {
    return pvi;
  }
  const _pvi = (Math.round(2147483647 * (Math.random() || 0.5)) * +new Date()) % 1e10;
  const year50 = 60 * 60 * 24 * 365 * 50;
  Cookies.set('pgv_pvi', _pvi, { domain: '.vlian.cn', expires: year50 });
  return _pvi;
};

const send = async (obj = {}) => {
  const isProduction = process.env.NODE_ENV === 'production';
  const token = isProduction ? Cookies.get('token1') : localStorage.getItem('token');
  request
    .post(
      process.env.VUE_APP_STAT_URL,
      { ...(await defaultParams()), ...obj },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      },
    )
    .then(() => {})
    .catch((error) => {
      console.error(error);
    });
};

const pv = () => {
  send();
};
const sendAction = (action) => {
  send(action);
};

export { pv, sendAction };
